import { VmsServiceJourneyStrip } from './VmsServiceJourneyStrip';
import { useVmsServiceJourneyStepUi } from '../../hooks/useVmsServiceJourneyStepUi';

/** Journey pills inline after active-service metadata (shared across VMS chrome strips). */
export function VmsServiceJourneyStripInline({
  registeredVendorId,
  vendorInitiationId,
  initiationApproved,
}: {
  registeredVendorId?: number | null;
  vendorInitiationId?: number | null;
  initiationApproved?: boolean;
}) {
  const stepUi = useVmsServiceJourneyStepUi({
    registeredVendorId,
    vendorInitiationId,
    initiationApproved,
  });

  return (
    <>
      <span className="hidden select-none text-sm font-light text-gray-300 sm:inline" aria-hidden>
        |
      </span>
      <div className="min-w-0 shrink-0 sm:ml-1">
        <VmsServiceJourneyStrip stepUi={stepUi} />
      </div>
    </>
  );
}
